







































































import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { tagGroupQuery, tagQuery, tagGroupEdit, tagEdit } from '@/api/strategyTag';
import { State, Getter, Action, Mutation, namespace } from 'vuex-class';

const quarterMap = {
  Q1: '1',
  Q2: '2',
  Q3: '3',
  Q4: '4',
  年度: '5'
};

const columns = [
  {
    title: '标签名称',
    dataIndex: 'name',
    key: 'name'
  },
  {
    title: '描述',
    dataIndex: 'description',
    key: 'description',
    width: '50%'
  },
  {
    title: '使用次数',
    dataIndex: 'useNum',
    key: 'useNum'
  },
  {
    title: '操作',
    key: 'action',
    scopedSlots: { customRender: 'action' }
  }
];

const data = [];

@Component({})
class StrategyTag extends Vue {
  tagGroupList: any[] = [];
  tagList: any[] = [];
  // isActive: number = 0;
  columns: any[] = columns;
  data: any[] = data;
  tagGroupNowId: number = 0;
  tagGroupVisible: boolean = false;
  tagVisible: boolean = false;

  labelCol: object = { span: 4 };
  wrapperCol: object = { span: 14 };
  formGroupTitle: string = '';
  formGroup: object = {
    name: '',
    description: ''
  };
  formTagTitle: string = '';
  formTag: object = {
    name: '',
    description: ''
  };

  formNowId: number = 0;

  rules: object = {
    name: [
      { required: true, message: '请输入分组名称!', trigger: 'blur' },
      { validator: this.validatePassGroup, trigger: 'blur' }
    ]
  };

  rules2: object = {
    name: [
      { required: true, message: '请输入标签名称!', trigger: 'blur' },
      { validator: this.validatePassTag, trigger: 'blur' }
    ]
  };

  mounted() {
    this.data = this.changeTagList(this.tagList);
    this.tagGroupNowId = 0;
    this.getTagGroup(1);
  }

  @Getter('token') token;

  get headers() {
    return { Authorization: this.token };
  }

  selectTagGroup(id) {
    this.tagGroupNowId = id;
    this.getTag(this.tagGroupNowId);
  }

  editTag(index) {
    console.log(index);

    // 1-新建,2-编辑
    this.formTagTitle = index === -1 ? '新建标签' : '编辑标签';
    if (index === -1) {
      this.formTag = {
        id: '',
        groupId: this.tagGroupNowId,
        name: '',
        description: ''
      };
      this.formNowId = 0;
    } else {
      this.$nextTick(() => {
        this.formTag = {
          id: index.id,
          groupId: this.tagGroupNowId,
          name: index.name,
          description: index.description
        };
      });
      this.formNowId = index.id;
    }
    this.tagVisible = true;
  }

  deleteTag(text) {
    let _this = this;
    if (text.useNum > 0) {
      this.$confirm({
        title: '删除确认',
        content: '删除后，项目中已经打上的标签也将被删除，确定删除？',
        onOk() {
          _this.tagEdit({ groupId: _this.tagGroupNowId, id: text.id, type: 2 });
        },
        onCancel() {}
      });
    } else {
      _this.tagEdit({ groupId: _this.tagGroupNowId, id: text.id, type: 2 });
    }
  }

  submitTagChange(e) {
    console.log(e);
    let tmp: any = this.$refs.ruleFormTag;
    tmp.validate(valid => {
      if (valid) {
        this.tagEdit({
          ...this.formTag,
          type: 1
        });
      } else {
        console.log('error submit!!');
        return false;
      }
    });
  }

  editTagGroup(type, index) {
    // 1-新建,2-编辑
    this.formGroupTitle = type === 1 ? '新建分组' : '编辑分组';
    if (type === 1) {
      this.formGroup = {
        name: '',
        description: ''
      };
      this.formNowId = 0;
    } else if (type === 2) {
      this.$nextTick(() => {
        this.formGroup = {
          name: this.tagGroupList[index].name,
          description: this.tagGroupList[index].description,
          id: this.tagGroupList[index].id
        };
      });

      this.formNowId = this.tagGroupList[index].id;
    }
    this.tagGroupVisible = true;
  }

  deleteTagGroup(index) {
    let _this = this;
    console.log('id:', index, this.tagGroupList[index]);

    this.formGroup = { id: this.tagGroupList[index]['id'] };
    if (this.tagGroupList[index].tagNum > 0) {
      this.$confirm({
        title: '删除确认',
        content: '删除后，标签组下的所有标签将被删除，且项目中已经打上的此标签组下标签也将被删除，确定删除？',
        onOk() {
          _this.tagGroupEdit(2);
        },
        onCancel() {}
      });
    } else {
      _this.tagGroupEdit(2);
    }
  }

  submitGroupChange(e) {
    console.log(e);
    let tmp: any = this.$refs.ruleFormGroup;
    tmp.validate(valid => {
      if (valid) {
        this.tagGroupEdit(this.formGroupTitle === '新建分组' ? 3 : 1);
      } else {
        console.log('error submit!!');
        return false;
      }
    });
  }

  cancelTagChange() {
    let tmp: any = this.$refs.ruleFormTag;
    setTimeout(() => {
      tmp.resetFields();
    }, 500);
  }

  cancelGroupChange() {
    let tmp: any = this.$refs.ruleFormGroup;
    setTimeout(() => {
      tmp.resetFields();
    }, 500);
  }

  changeTagList(list) {
    list.forEach(_ => {
      _.key = _.id;
    });
    return list;
  }

  async getTagGroup(type) {
    // 1 - init&refresh,选中第一条
    // 2 - refresh,选中不发生改变
    // 3 - refresh,选中最后一条的
    try {
      let res = await tagGroupQuery();
      if (res.code === 200) {
        this.tagGroupList = res.data.list;
        if (type === 1) {
          if(this.tagGroupList.length > 0) {
            this.selectTagGroup(this.tagGroupList[0].id);
          } else {
            this.tagList = [];
            this.data = [];
          }
        } else if (type === 2) {
          this.getTag(this.tagGroupNowId);
        } else {
          let i = this.tagGroupList[this.tagGroupList.length - 1].id;
          this.selectTagGroup(i);
        }
      } else {
        // this.$message.error(res.msg);
      }
    } catch (err) {
      console.log(err);
    }
  }

  async getTag(groupId) {
    try {
      let res = await tagQuery({
        groupId: groupId
      });
      if (res.code === 200) {
        this.tagList = res.data.list;
        this.data = this.changeTagList(this.tagList);
      } else {
        // this.$message.error(res.msg);
      }
    } catch (err) {
      console.log(err);
    }
  }

  async tagGroupEdit(type) {
    // 前端type 1/编辑 2/删除 3/新增
    // 后端接口 1.编辑/新增 2. 删除
    try {
      let res = await tagGroupEdit({
        ...this.formGroup,
        type: type === 3 ? 1 : type
      });
      if (res.code === 200) {
        if (type === 2) {
          this.$message.success('删除成功');
        }
        if (type === 3) {
          this.getTagGroup(3);
        } else if (this.formGroup['id'] === this.tagGroupNowId && type === 2) {
          this.getTagGroup(1);
        } else {
          this.getTagGroup(2);
        }
        let tmp: any = this.$refs.ruleFormGroup;
        tmp.resetFields();
        this.tagGroupVisible = false;
      } else {
        // this.$message.error(res.msg);
      }
    } catch (err) {
      console.log(err);
    }
  }

  async tagEdit(body) {
    // 1.编辑/新增 2. 删除
    try {
      // if(this.formTagTitle === '编辑')
      let res = await tagEdit(body);
      if (res.code === 200) {
        if (body.type === 2) {
          this.$message.success('删除成功');
        }
        this.getTagGroup(2);
        this.formGroup = {
          name: '',
          description: ''
        };
        let tmp: any = this.$refs.ruleFormTag;
        tmp.resetFields();
        this.tagVisible = false;
      } else {
        // this.$message.error(res.msg);
      }
    } catch (err) {
      console.log(err);
    }
  }

  validatePassGroup(rule, value, callback) {
    if (value === '') {
      callback(new Error('请输入分组名称!'));
    } else if (this.tagGroupList.find(_ => _.name === value && _.id !== this.formNowId)) {
      callback(new Error('当前分组已存在，请重新输入!'));
    } else {
      callback();
    }
  }

  validatePassTag(rule, value, callback) {
    if (value === '') {
      callback(new Error('请输入标签名称!'));
    } else if (this.tagList.find(_ => _.name === value && _.id !== this.formNowId)) {
      callback(new Error('当前标签已存在，请重新输入!'));
    } else {
      callback();
    }
  }
}
export default StrategyTag;
